import RenderOnRole from '../../../../components/RenderOnRole'
import { HISTORY_READ, HISTORY_WRITE } from '../../../../utils/roles'
import HistoryExaminationFormTemplate from '../HistoryExaminationFormTemplate'

const HistoryDental = () => {
  return (
    <RenderOnRole
      roles={[HISTORY_READ, HISTORY_WRITE]}
      element={
        <HistoryExaminationFormTemplate intent='historyAndExaminationDental' />
      }
    />
  )
}

export default HistoryDental
